<div class="order-details-wrapper product-detail-row">
    <div class="order-details ">
      <div class="row ">

        <div class="col-md-12 order-details-title">
          <label class="special-title">
            פרטי ההזמנה שלך
          </label>

        </div>
        <div class="col-md-12 order-details-details">
          <div class="order-details-row">
            נושא:
            <span class="order-detail-important">{{productView?.ProductItem?.Name}}</span>.
          </div>
          <div *ngIf="chosenOption && chosenOption.ProductOptionItem && chosenOption.ProductOptionItem.ApartmentSizeTypeTxt" class="order-details-row">
            <span [innerHtml]="chosenOption.ProductOptionItem.ApartmentSizeTypeTxt"></span>:
            <span class="order-detail-important">{{pUiService.apartmentSize.value}}</span>.

          </div>
          <div class="order-details-row">
            זמן לקבלת התוכנית:
            <span class="order-detail-important" *ngIf="pUiService.timeToGetProgramInDays?.value">{{pUiService.timeToGetProgramInDays.value}} ימים</span>
            <span *ngIf="pUiService.timeToGetProgramInDays?.value==1" class="order-detail-important">יום אחד</span>.
          </div>
          <div class="order-details-row">
            פורמט התוכנית הקיימת
            <span class="help-icon" triggers="click:blur" placement="left" [ngbTooltip]="tipContent1">?</span>:
            <ng-template #tipContent1>
              <div class='help-tooltip'>סוג הקובץ של התכנית שיש ברשותך.
                <br />קובץ תמונה : JPEG (תמונה מהטלפון/צילום מסך וכדו')
                <br />קובץ מסמך סרוק: PDF
                <br />קובץ של תכנת שירטוט אוטוקד: DWG (קיימת אצל אדריכלים ובמחלקות שינויי הדיירים של הקבלנים)
                <br />בסיומת כל קובץ תוכלו לזהות בעצמכם את סוג הקובץ: xy.dwg, xy.jpeg, xy.pdf</div>
            </ng-template>
            <span class="order-detail-important">{{pUiService.existFileFormat?.value}}</span>.
          </div>
          <div class="order-details-row">
            פורמט התוכנית שתתקבל
            <ng-template #tipContent2>

              <div class='help-tooltip'>סוג הקובץ של התכנית שתשלח אליך.
                <br>קובץ תמונה : JPEG (תמונה מהטלפון/צילום מסך וכדו')
                <br>קובץ מסמך סרוק: PDF
                <br>קובץ של תכנת שירטוט אוטוקד: DWG (קיימת אצל אדריכלים ובמחלקות שינויי הדיירים של הקבלנים)
                <br>בסיומת כל קובץ תוכלו לזהות בעצמכם את סוג הקובץ: xy.dwg, xy.jpeg, xy.pdf</div>

            </ng-template>
            <a class="help-icon" triggers="click:blur" placement="left" [ngbTooltip]="tipContent2">?</a>:
            <span class="order-detail-important">{{pUiService.wantedFileFormat?.value}}</span>.
          </div>
          <div class="order-details-row">
            מספר תיקונים
            <ng-template #tipContent3>

              <div class='help-tooltip'>כמות התיקונים המרבית שתוכלו לבקש לאחר שהתכנית הראשונית נשלחה אליכם ממערכת
                תכנון אונליין.</div>

            </ng-template>
            <span class="help-icon" triggers="click:blur" placement="left" [ngbTooltip]="tipContent3">?</span>
            :
            <span class="order-detail-important" *ngIf="pUiService.fixesTimes?.value>1">
              {{pUiService.fixesTimes?.value}} תיקונים</span>
            <span class="order-detail-important" *ngIf="pUiService.fixesTimes?.value==1">תיקון אחד בלבד</span>.
          </div>
          <div *ngIf="pUiService.isForOperate?.value" class="order-details-row is-operate-sum">
            <span>*התוכנית מיועדת לביצוע</span>.
          </div>

          <div class="order-details-row">
            מחיר הזמנה:
            <span class="order-detail-important">{{(pUiService.finalPrice.value*100/118) | number: pUiService.DECIMAL_RULE }} ₪</span>.
          </div>
          <div class="order-details-row">
            18% מע"מ:
            <span class="order-detail-important">{{(pUiService.finalPrice.value - pUiService.finalPrice.value*100/118) | number: pUiService.DECIMAL_RULE}} ₪</span>.
          </div>
          <div class="order-details-row">
            מחיר סופי:
            <span class="order-detail-important">{{pUiService.finalPrice.value | number: pUiService.DECIMAL_RULE}} ₪</span>.
          </div>
          <div class="order-details-row edit-order-again-wrapper">
              <div class="edit-order-again" (click)="backToStageOneFn()">לחזרה לשלב 1 לעריכת פרטי ההזמנה</div>
            </div>
        </div>

      </div>
    </div>
  </div>